import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { dashboardCountsProps } from "../types";

export const QUERY_KEY_FOR_TALENT_DASHBOARD_COUNT = "talent_dashboard";

const getData = async (props: {
  token: string;
}): Promise<dashboardCountsProps> => {
  const url = `${END_POINT.BASE_URL}/v1/talent_dashboard`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);

  const item: dashboardCountsProps = res.data;
  const data: dashboardCountsProps = {
    ...item,
  };

  return data;
};

export const useGetTalentCount = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_TALENT_DASHBOARD_COUNT],
    () => getData({ token }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (err: any) => { },
      onSuccess: (data) => { },
    }
  );

  return queryData;
};
